import Tabs from './Tabs';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import ApplicationHeader from './ApplicationHeader';
import { fetchApplications } from '../../../redux/features/applicationSlice';
import apiFetch from '../../../utlis/apiFetch';

const MainExistApplications = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [propsData, setPropsData] = useState(null);
  const user = JSON.parse(localStorage.getItem('user'));
  const newData = useSelector((state) => state.createApplication.newData);
  const { applications } = useSelector((state) => state.application);
  const applicationsList = Array.isArray(applications)
    ? applications
    : Array.isArray(applications?.applications)
    ? applications.applications
    : [];
  const [isFetchingById, setIsFetchingById] = useState(false);
  const [fetchByIdError, setFetchByIdError] = useState(null);

  const handleNewApplication = () => {
    if (
      newData.interestOfCountry === '' ||
      newData.visaCategory === '' ||
      newData.status === ''
    ) {
      console.log('data not found');
      navigate('/client');
      return;
    }

    // Check if newData.id exists and matches an application
    if (newData?.id !== 'new' && newData.id !== '') {
      console.log('id __________________ found');
      const existingApplication = newData.id
        ? applicationsList.find((app) => app._id === newData.id)
        : null;
      console.log(existingApplication);
      setPropsData({ ...existingApplication });
    } else {
      console.log('+++++++++++++++++== handleNewApplication');
      const mergedData = {
        ...newData,
        ...user,
      };
      setPropsData(mergedData);
    }
  };

  const handleExistApplication = async () => {
    try {
      setIsFetchingById(true);
      setFetchByIdError(null);

      const token = localStorage.getItem('token');
      if (!token) throw new Error('No authentication token found');

      const response = await apiFetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/application/getApplication/${id}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = response._data ?? (await response.json());
      if (!response.ok)
        throw new Error(data?.message || 'Failed to fetch application');

      const fetchedApplication = data?.body || data?.application || data;
      setPropsData({ ...fetchedApplication });

      // Keep the list in sync for client applications page.
      dispatch(fetchApplications());
    } catch (error) {
      console.error('Failed to fetch application by id:', error);
      const existingApplication = applicationsList.find(
        (application) => application._id === id
      );

      if (existingApplication) {
        setPropsData({ ...existingApplication });
        setFetchByIdError(null);
      } else {
        setFetchByIdError(error.message || 'Failed to fetch application');
      }
    } finally {
      setIsFetchingById(false);
    }
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    console.log(newData.id);

    if (id === 'new') {
      console.log('handleNewApplication');
      handleNewApplication();
    } else {
      console.log('handleExistApplication');
      handleExistApplication();
    }
  }, [id]);

  const handleRefresh = (freshData) => {
    if (freshData?._id) {
      setPropsData({ ...freshData });
    }
  };

  return (
    <div className="md:p-4 md:space-y-5">
      {isFetchingById && (
        <div className="flex items-center justify-center min-h-[200px]">
          <div className="w-8 h-8 border-4 border-blue-900 border-t-transparent rounded-full animate-spin" />
        </div>
      )}
      {propsData && (
        <>
          <ApplicationHeader propsData={propsData} />
          {/* <ApplicationForm selectedData={applicationData} /> */}
          <Tabs propsData={propsData} onRefresh={handleRefresh} />
        </>
      )}
      {fetchByIdError && !propsData && (
        <p className="text-red-500 text-center text-sm">{fetchByIdError}</p>
      )}
    </div>
  );
};

export default MainExistApplications;
